import { Routes } from '@angular/router';
import { permissionGuard } from '@core/auth/permission.guard';
import { APP_PERMISSIONS } from '@core/constants/permission.constants';
import { APP_ROUTES } from '@core/constants/routes.constants';

// `new` is listed before the `:id` route so it is not read as an id.
export const assessmentsRoutes: Routes = [
  {
    title: 'pagesTitles.assessmentCreate',
    path: APP_ROUTES.ASSESSMENTS_NEW,
    canActivate: [permissionGuard(APP_PERMISSIONS.AssessmentsCreate)],
    loadComponent: () => import('./pages/create-assessment').then((m) => m.CreateAssessment),
  },
  {
    title: 'pagesTitles.assessmentDetail',
    path: APP_ROUTES.ASSESSMENTS_DETAIL,
    canActivate: [permissionGuard(APP_PERMISSIONS.AssessmentsRead)],
    loadComponent: () => import('./pages/show-assessment').then((m) => m.ShowAssessment),
  },
  {
    title: 'pagesTitles.assessmentBaseline',
    path: APP_ROUTES.ASSESSMENTS_BASELINE,
    canActivate: [permissionGuard(APP_PERMISSIONS.HazardBaselineInputsRead)],
    loadComponent: () => import('./pages/assessment-baseline').then((m) => m.AssessmentBaseline),
  },
  {
    title: 'pagesTitles.assessmentRegionalImpact',
    path: APP_ROUTES.ASSESSMENTS_REGIONAL,
    canActivate: [permissionGuard(APP_PERMISSIONS.AssessmentClimateImpactRead)],
    loadComponent: () =>
      import('./pages/assessment-regional-impact').then((m) => m.AssessmentRegionalImpact),
  },
  {
    title: 'pagesTitles.assessmentLocalNational',
    path: APP_ROUTES.ASSESSMENTS_LOCAL_NATIONAL,
    canActivate: [permissionGuard(APP_PERMISSIONS.AssessmentClimateImpactRead)],
    loadComponent: () =>
      import('./pages/assessment-local-national').then((m) => m.AssessmentLocalNational),
  },
  {
    title: 'pagesTitles.assessmentIntegrated',
    path: APP_ROUTES.ASSESSMENTS_INTEGRATED,
    canActivate: [permissionGuard(APP_PERMISSIONS.AssessmentClimateImpactRead)],
    loadComponent: () =>
      import('./pages/assessment-integrated').then((m) => m.AssessmentIntegrated),
  },
];
